import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "SearchService" */ './lazyIndex'),
    { name: 'SearchService' }
);

export const lazyLogLocalContentDataSource: LazyAction<
    typeof lazyIndex.logLocalContentDataSource,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logLocalContentDataSource);

export const lazyLogLocalContentLayout: LazyAction<
    typeof lazyIndex.logLocalContentLayout,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logLocalContentLayout);

export const lazyClearLocalContentInstrumentationCache: LazyAction<
    typeof lazyIndex.clearLocalContentInstrumentationCache,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.clearLocalContentInstrumentationCache);

export const lazyGetLocalContentId: LazyImport<
    typeof lazyIndex.getLocalContentId,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getLocalContentId);

export const lazySubstrateSearchInitOperation: LazyImport<
    typeof lazyIndex.substrateSearchInitOperation,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.substrateSearchInitOperation);
export const lazySubstrateSearchPostSuggestionsService: LazyImport<
    typeof lazyIndex.substrateSearchPostSuggestionsService,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.substrateSearchPostSuggestionsService);

export const lazyDeleteSubstrateSearchHistoryService: LazyImport<
    typeof lazyIndex.deleteSubstrateSearchHistoryService,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.deleteSubstrateSearchHistoryService);
export const lazyExportSubstrateSearchHistoryService: LazyImport<
    typeof lazyIndex.exportSubstrateSearchHistoryService,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.exportSubstrateSearchHistoryService);

export const lazyCreateImplicitContactFilter: LazyImport<
    typeof lazyIndex.createImplicitContactFilter,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.createImplicitContactFilter);
